import {useState,useEffect,useContext} from 'react';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {BiSearchAlt} from 'react-icons/bi';
import { Card,CardBody,CardHeader, List } from 'reactstrap';
import {Tabs,Tab,Typography,Box,TextField,Button,IconButton, Grid} from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CasUserContext } from '../../services/casUserContext';
import BusqPersonalTable from './BusqPersonalTable';
import { ProyectoPorUsuario } from '../../interfaces/BusquedaPersonalDTO';
import ProyectoService from '../../services/ProyectoService';
import AlertService from '../../services/AlertService';
import { OptionReactSelect, Usuario, setUsuarioSelectCedula, setUsuarioSelectUsuario } from '../../interfaces/UsuarioSearch';
import UsuarioService from '../../services/UsuarioService';
import Select from 'react-select';
import { PersonaInvDTO } from '../../interfaces/Usuarios/PersonaInvDTO';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const proyectoService = new ProyectoService();
const alertaService = new AlertService();
const usuarioService = new UsuarioService();

export function BusquedaPersonal() {
 const {id} = useParams();   
 const[data,setData] = useState<Array<ProyectoPorUsuario>>([]);
 const[archivo,setArchivo] = useState('');
 const[tab,setTab] = useState(0);
 const[usuario,setUsuario] = useState('');
 const[cedula,setCedula] = useState('');
 const[listUsuario,setListUsuario] = useState<Array<PersonaInvDTO>>([]);
 const[listUser,setListUser] = useState<Array<OptionReactSelect>>([]);
 const[listPersona,setListPersona] = useState<Array<OptionReactSelect>>([]);
 const[ready,setReady] = useState(false);
 const casUserContext = useContext(CasUserContext);
 const userData = casUserContext.userData;
 const token = casUserContext.token;

 const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  setTab(newValue);
 };

 const fetchData = async () =>{
  try{     
       await usuarioService.GetListUsuarios(token)
       .then((data) => {
            //console.log(data);
            if(data.status.isSuccessfully){
              setListUsuario(data.listData);
              setListUser(setUsuarioSelectUsuario(data.listData));
              setReady(true);
            }else{
              alertaService.alertaAdvertencia("Error","No se cargaron los usuarios");
              setReady(false);
            }
        })               
       .catch((error) => console.error(error));                        
  }catch(error){
    console.error('Error:',error);
  }
};

const BuscarPorApellidos = async () =>{
  try{     
       await usuarioService.GetListUsuarios(token)
       .then((data) => {
            //console.log(data);
            if(data.status.isSuccessfully){
              setListPersona(setUsuarioSelectCedula(data.listData));
            }else{
              alertaService.alertaAdvertencia("Error","No se cargaron los usuarios");
            }
        })               
       .catch((error) => console.error(error));                        
  }catch(error){
    console.error('Error:',error);
  }
};

 const handleUsuarioSearch = async () =>{
  try{
    alertaService.showLoading("Espere...");
    setData([]);
    await proyectoService.GetProyectoByEmailCedula("N",usuario,0,token)
            .then((data) => {
                //console.log(data.objDatos);
                setData(data.data.listaproyectos);
                setArchivo(data.data.archivoExcel);
                alertaService.hideLoading();
            })
            .catch((error) => {
              console.error(error)
              alertaService.hideLoading();
              alertaService.alertaAdvertencia('ATENCIÓN','Problemas con el servicio');
            });
  }catch(error){
    console.error('Error:',error);
  }
 };

 const handleCedulaSearch = async () =>{
  try{
    alertaService.showLoading("Espere...");
    setData([]);
    await proyectoService.GetProyectoByEmailCedula(cedula,"N",0,token)
            .then((data) => {
                //console.log(data.objDatos);
                setData(data.data.listaproyectos);
                setArchivo(data.data.archivoExcel);
                alertaService.hideLoading();
            })
            .catch((error) => {
              console.error(error)
              alertaService.hideLoading();
              alertaService.alertaAdvertencia('ATENCIÓN','Problemas con el servicio');
            });
  }catch(error){
    console.error('Error:',error);
  }
 };

  //Seccion Carga
  useEffect(() => {  
    fetchData();
   },[]);
 
  return (
      <Card>
      <CardHeader>Busqueda Personal</CardHeader>
      <CardBody>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Usuario" {...a11yProps(0)} />
          <Tab label="Identificación" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <Grid container spacing={2} sx={{alignItems: 'left', marginBottom:2}}>
         <Grid item xs={12} sm={12} md={10} lg={10}>
          <Select
                className="app-select-react"
                classNamePrefix="select"
                defaultValue={listUser[0]}
                isDisabled={!ready}
                isLoading={!ready}
                isSearchable={ready}
                name="usuario"
                options={listUser}
                placeholder="Seleccione Usuario"
                onChange={(e) => {
                  setUsuario(e?.value || '')
                }}
              />
         </Grid>
         <Grid item xs={12} sm={12} md={2} lg={2}>
          <Button size="medium" variant="contained" endIcon={<BiSearchAlt />} onClick={() => {handleUsuarioSearch()}}>Buscar</Button>
         </Grid>
        </Grid>      
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <Grid container spacing={2} sx={{alignItems: 'left', marginBottom:2}}>
          <Grid item xs={12} sm={12} md={10} lg={10}>
            <TextField
              required
              id="outlined-required"
              label="Identificación"
              sx={{ m: 1, width: '100%' }}
              size="small"
              value={cedula}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCedula(event.target.value);
              }}
            />
          </Grid>
          {/* <Grid item xs={12} sm={12} md={10} lg={10}>
              <Select
                    className="app-select-react"
                    classNamePrefix="select"
                    defaultValue={listPersona[0]}
                    isDisabled={!ready}
                    isLoading={!ready}
                    isSearchable={ready}
                    name="usuario"
                    options={listPersona}
                    placeholder="Seleccione Usuario"
                    onChange={(e) => setUsuario(e?.value || '')}
                  />
          </Grid> */}
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <Button size="medium" sx={{ m: 1 }} variant="contained" endIcon={<BiSearchAlt />} onClick={() => {handleCedulaSearch()}}>Buscar</Button>
          </Grid>
        </Grid> 
      </TabPanel>
      </Box>
      <BusqPersonalTable token={token} iduser={userData.idinv} rowsPerPage={[5 ,10, 25, 100]} data={data} archivo={archivo} />
    </CardBody>
   </Card>
  )
}